<template>
  <el-table-column
    :label="label"
    :prop="prop"
    :class-name="className"
    :sortable="sortable"
  >
    <template slot-scope="scope">
      <i v-if='correct(scope.row, scope.$index)' class="el-icon-success"></i>
      <i v-else class="el-icon-error"></i>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'c\'k'
    },
    prop: {
      type: String,
      default: 'data_check_flag'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: 'data-check-flag'
    },
    correct: {
      type: Function,
      default: () => true
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.data-check-flag {
      width: 6em;
    }
  }
  i.el-icon-success {
    font-size: 1.7em;
    color: #3cb371;
  }
  i.el-icon-error {
    font-size: 1.7em;
    color: #dc143c;
  }
}
</style>
